module.exports = __webpack_public_path__ + "img/informe-medico.6a3ee754.png";